import React from 'react';
import AirTableFormModel from '../../models/air-table-form';
import styles from './air-table-form.module.scss';

interface Props {
  data: AirTableFormModel;
}

const AirTableForm = ({ data: { id } }: Props) => (
  <iframe
    title="air-table-iframe"
    className={styles['air-table-form']}
    src={`https://airtable.com/embed/${id}`}
  />
);

export default AirTableForm;
